package api.service.auth

import dev.gitlive.firebase.auth.FirebaseAuthException
import firebaseAuth
import kotlinx.coroutines.flow.firstOrNull
import kotlinx.coroutines.flow.single

object ImplServiceAuthentication: ServiceAuthentication{
    override suspend fun login(email: String, password: String): Boolean {
       return !(email.isEmpty() || password.isEmpty())
    }

    override suspend fun logout() {
        true
    }

    override suspend fun checkCurrentUser(): Boolean {
       return if (firebaseAuth.authStateChanged.firstOrNull() != null){
            true
        } else false

    }
}